import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import { selectAuth } from "../../components/auth/auth.selector";
import FPForm from "../../components/diet/fitness-profile/FPForm";
import "../../styles/diet/diet.css";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import { fetchDietCardsData } from "../../redux/reducers/apiSlice";
import { formatDateTimezon } from "../../components/common-data/Converts";
import { BodyBuilder } from "../../exports/Images";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const FitnessProfile = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const userInfoData = userInfo?.user || {};
  const { dietPlanLoading, dietCardsData } = useSelector((state) => state.api);

  // const [modals, setModal] = useState(false);
  const iniAllFilters = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    page: isPage + 1,
    search: "",
    type: "total_members",
    limit: 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniMemData = {
    tbData: [],
    isPage: 0,
    pagination: [],
  };
  const [membersData, setMembersData] = useState(iniMemData);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: {},
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getMembers() {
    const filterString = `&type=${filters.type}&search=${
      filters.search ? filters.search : ""
    }`;

    dispatch(
      fetchDietCardsData({
        pageNo: filters.page,
        limit: filters.limit,
        queryParameters: filterString,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getMembers();
  }, [filters.isPage, filters.search]);

  useEffect(() => {
    if (dietCardsData?.status && dietCardsData?.data) {
      const { data, pagination } = dietCardsData || {};

      setMembersData((prevs) => ({
        ...prevs,
        tbData: data,
        pagination: pagination,
      }));
    } else {
      setMembersData((prevs) => ({ ...prevs, tbData: [], pagination: [] }));
    }
  }, [dietCardsData]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    // {
    //   dataField: "action",
    //   text: "Action",
    //   formatter: (cell, row) => (
    //     <div className="actionButtonContainer">
    //       <button
    //         type="button"
    //         className={`actionBtn icon edit`}
    //         onClick={() => {
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             cardType: "edit",
    //             rowData: row,
    //           }));
    //         }}
    //       >
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="16"
    //           height="16"
    //           fill="currentColor"
    //           className="bi bi-pencil-fill"
    //           viewBox="0 0 16 16"
    //           style={{
    //             color: "#c71010",
    //             cursor: "pointer",
    //           }}
    //         >
    //           <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
    //         </svg>
    //       </button>
    //     </div>
    //   ),
    // },
    {
      dataField: "user_profile",
      text: "Member Profile",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.user_profile || BodyBuilder}
              alt={row?.user_name || "NA"}
              className="image"
            />
          </div>
        );
      },
    },
    {
      dataField: "user_name",
      text: "Member Info / Fitness Profile",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}
            {row?.is_completed === 1 ? (
               <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}

            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "dietician_name",
    //   text: "dietician name",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.dietician_name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "gym_name",
      text: "gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "current_plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.current_plan_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "current plan status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 minWidth150"
            style={{
              background:
                row?.current_plan_status === "active" ? "#E2EFD5" : "#F3DADA",
              color:
                row?.current_plan_status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.current_plan_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "assigned_dietpackage_name",
      text: "diet package (KCAL)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.assigned_dietpackage_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "body_type",
      text: "Diet Type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.body_type || "NA"}</span>;
      },
    },
    {
      dataField: "user_dietpreference",
      text: "diet Preference",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{row?.user_dietpreference || "NA"}</span>
        );
      },
    },
    {
      dataField: "age",
      text: "age/gender",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.age || 0} ({row?.gender || "NA"})
          </span>
        );
      },
    },
    {
      dataField: "height",
      text: "height(Inch)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.height || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "weight",
      text: "weight (Kg)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.weight || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "target_weight",
      text: "target weight (Kg)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.target_weight || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "bmi_result",
      text: "BMI",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.bmi_result || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "fat_result",
      text: "fat",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.fat_result || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "calorie_result",
      text: "calorie",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.calorie_result || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "calorie_target_result",
      text: "target calorie",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {parseFloat(row?.calorie_target_result || 0).toFixed(2)}
          </span>
        );
      },
    },
    {
      dataField: "how_active",
      text: "how active",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.how_active || "NA"}</span>;
      },
    },
    {
      dataField: "existing_disease",
      text: "Medical Condition",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.existing_disease || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Member Fitness Profile">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Add Modal"
          ariaHideApp={false}
        >
          <FPForm
            onCloseModal={closeModal}
            userInfoData={userInfoData}
            isEdit={modValues.cardType === "edit" ? true : false}
            rowData={modValues.rowData}
            callFunction={() => getMembers()}
          />
        </Modal>

        <Row>
          <Col>
            <MealsStructure text={"Fitness Profile"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <SearchNButtons
              pageName={"fitness_profile"}
              btnText={"+ Member Fitness Profile"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardType: "add",
                }))
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              {dietPlanLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={membersData.tbData}
                  tableColumns={tbColumns}
                  tablePagination={membersData.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default FitnessProfile;
